var React = require('react');

function PatternTriangle3Oblique (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Pattern/TripleTriangle/Green"),React.createElement("path",{"d":"M99.375 109.656H34.78L67.907 55l32.297 53.29L132.5 55l33.125 54.656h-66.25zm32.297-56.022L163.97.344 197.093 55H66.25L99.375.344l32.297 53.29zm1.656 109.312l32.297-53.29 33.125 54.656H67.906l33.125-54.656 32.3 53.29zm98.547-53.29L265 164.312h-66.25l33.125-54.656zM198.75 55l33.125 54.656h-66.25L198.75 55zM33.125.344L66.25 55H0L33.125.344z","fill":"#F79186","fillRule":"evenodd","key":1})]);
}

PatternTriangle3Oblique.defaultProps = {"width":"265","height":"165","viewBox":"0 0 265 165"};

module.exports = PatternTriangle3Oblique;

PatternTriangle3Oblique.default = PatternTriangle3Oblique;
